import { axios } from '@/utils/request'

const api = {
  cateTreeList: '/adminapi/cms/cateTreeList',
  cateList: '/adminapi/cms/cateList',
  cateAdd: '/adminapi/cms/cateAdd',
  cateEdit: '/adminapi/cms/cateEdit',
  setCateRank: '/adminapi/cms/setCateRank',
  cateDelete: '/adminapi/cms/cateDelete',
  cateDetail: '/adminapi/cms/cateDetail',
  contentList: '/adminapi/cms/contentList',
  contentOptions: '/adminapi/cms/contentOptions',
  contentAdd: '/adminapi/cms/contentAdd',
  contentEdit: '/adminapi/cms/contentEdit',
  contentDetail: '/adminapi/cms/contentDetail',
  contentDelete: '/adminapi/cms/contentDelete',
  contentCopy: '/adminapi/cms/contentCopy',
  setContentRank: '/adminapi/cms/setContentRank',
  setContentAllStatus: '/adminapi/cms/setContentAllStatus',
}

export default api

export function getContentList(parameter) {
  return axios({
    url: api.contentList,
    method: 'get',
    params: parameter
  })
}

export function getContentOptions(parameter) {
  return axios({
    url: api.contentOptions,
    method: 'get',
    params: parameter
  })
}
export function getContentDetail(parameter) {
  return axios({
    url: api.contentDetail,
    method: 'get',
    params: parameter
  })
}
export function getCateTreeList(parameter) {
  return axios({
    url: api.cateTreeList,
    method: 'get',
    params: parameter
  })
}
export function getCateList(parameter) {
  return axios({
    url: api.cateList,
    method: 'get',
    params: parameter
  })
}
export function addContent(parameter) {
  return axios({
    url: api.contentAdd,
    method: 'post',
    data: parameter
  })
}
export function editContent(parameter) {
  return axios({
    url: api.contentEdit,
    method: 'post',
    data: parameter
  })
}
export function addCate(parameter) {
  return axios({
    url: api.cateAdd,
    method: 'post',
    data: parameter
  })
}
export function editCate(parameter) {
  return axios({
    url: api.cateEdit,
    method: 'post',
    data: parameter
  })
}
export function deleteCate(parameter) {
  return axios({
    url: api.cateDelete,
    method: 'post',
    data: parameter
  })
}
export function setContentRank(parameter) {
  return axios({
    url: api.setContentRank,
    method: 'post',
    data: parameter
  })
}
export function getCateDetail(parameter) {
  return axios({
    url: api.cateDetail,
    method: 'get',
    params: parameter
  })
}

export function deleteContent(parameter) {
  return axios({
    url: api.contentDelete,
    method: 'post',
    data: parameter
  })
}
export function copyContent(parameter) {
  return axios({
    url: api.contentCopy,
    method: 'post',
    data: parameter
  })
}

export function setContentAllStatus(parameter) {
  return axios({
    url: api.setContentAllStatus,
    method: 'post',
    data: parameter
  })
}

export function setCateRank(parameter) {
  return axios({
    url: api.setCateRank,
    method: 'post',
    data: parameter
  })
}
